<template>
  <section :class="$style.container">
    <template v-if="spinShow">
      <loading></loading>
    </template>
    <section>
      <div :class="$style.topBox">
        <div :class="$style.top">
          <router-link
            :to="{ path: '/' }"
            tag="div"
            style="display: inline-block"
          >
            <!-- <img :src="logoUrl" :class="$style.logo" /> -->
            <img src="./imgs/logo.png" :class="$style.logo" />
          </router-link>
        </div>
      </div>
      <div :class="$style.center">
        <div :class="$style.box">
          <div :class="$style.login" class="a_tab">
            <!-- <div
              id="WX_login"
              @click="WxLogin"
              v-if="activeName === 'messageLogin'"
            >
              <div class="login_item"></div>
            </div> -->
            <div v-if="!flag" id="login_container">
              <wxlogin
                :appid="appid"
                :scope="scope"
                :redirect_uri="redirect_uri"
                :state="state"
              ></wxlogin>
            </div>
            <div v-if="flag">
              <Tabs @on-click="handleChangeItem" v-if="tab1">
                <TabPane label="用户登录" name="pwdLogin" v-model="activeName">
                  <PwdLogin
                    :isSelect="isPwdSelect"
                    @messageLogin="changeTabClick"
                    @login="handleLoginClick"
                  />
                </TabPane>
                <TabPane label="分销商登录" name="distroutorLogin">
                  <DistroutorLogin
                    :isSelect="isDistorSelect"
                    @login="handleLoginClick"
                  />
                </TabPane>
              </Tabs>
              <Tabs @on-click="handleChangeItem" v-else v-model="activeName">
                <TabPane label="用户登录" name="messageLogin">
                  <MessageLogin
                    @pwdLogin="changeTabClick"
                    @login="handleLoginClick"
                  />
                </TabPane>
                <TabPane label="分销商登录" name="distroutorLogin">
                  <DistroutorLogin
                    :isSelect="isDistorSelect"
                    @login="handleLoginClick"
                  />
                </TabPane>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      <div :class="$style.bottom">
        <div class="foot-copyright">
          <ul class="linkstring">
            <li>
              <router-link :to="{ name: 'tourist' }">免费注册</router-link>
            </li>
            <li><a @click="gotoList(7)">关于我们</a></li>
            <li><a @click="gotoList(9)">联系我们</a></li>
            <li><a @click="gotoList(10)">招聘英才</a></li>
            <li><a @click="gotoList(2)">帮助中心</a></li>
          </ul>
          <a class="z-csr1" v-html="copyright"></a>
          <a
            href="http://www.hqyatu.com/"
            target="_blank"
            style="margin-top: 12px"
            >环球雅途集团有限公司提供技术支持</a
          >
        </div>
      </div>
    </section>

    <Modal v-model="showAlert" ok-text="同意" cancel-text="不同意" @on-ok="ok">
      <p
        style="
          color: #333;
          font-size: 16px;
          padding: 50px 0px;
          text-align: center;
        "
      >
        已阅读并同意《
        <span style="color: #4e81f0" @click.stop="handleServiceRuleClick"
          >环球雅途易旅通注册服务条款</span
        >》
      </p>
    </Modal>

    <Modal
      v-model="isModalShow"
      width="1000"
      :closable="true"
      :mask-closable="false"
    >
      <p slot="header">注册服务条款</p>
      <div>
        <member></member>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="primary" class="op-btns ok-btn" @click="hideModal"
          >确定</Button
        >
      </div>
    </Modal>
  </section>
</template>

<script>
import wxlogin from "./vue-wxlogin";
import PwdLogin from "./components/pwdLogin";
import MessageLogin from "./components/message";
import DistroutorLogin from "./components/distroutorLogin";
import member from "./membershipClause";
import CryptoJS from "crypto-js";
export default {
  data() {
    return {
      state: Math.ceil(Math.random() * 1000),
      appid: "wx2241fd66f81ab40f",
      scope: "snsapi_login",
      redirect_uri: "http://jcfx.yilvbao.cn/ec/custom/callback",
      flag: true,
      activeName: "messageLogin",
      tab1: false,
      showAlert: false,
      isModalShow: false,
      spinShow: false,
      message: {},
      copyright: "",
      isPwdSelect: false, // 密码登录是否记住密码
      isDistorSelect: false, // 分销商登录是否自动登录
      logoUrl: "",
    };
  },
  components: {
    PwdLogin,
    MessageLogin,
    DistroutorLogin,
    member,
    wxlogin,
  },
  created() {
    this.init();
  },
  methods: {
    // 微信扫码登录
    WxLogin() {
      this.flag = !this.flag;
    },
    // 加密方法
    aesMinEncrypt: function (key, iv, word) {
      var _word = CryptoJS.enc.Utf8.parse(word),
        _key = CryptoJS.enc.Utf8.parse(key),
        _iv = CryptoJS.enc.Utf8.parse(iv);
      var encrypted = CryptoJS.AES.encrypt(_word, _key, {
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    async init() {
      this.$store.commit("setMenuIndex", "1"); //避免点击返回首页时，未正确显示首页
      if (sessionStorage.getItem("userInfo")) {
        this.isPwdSelect = true;
        this.form = JSON.parse(sessionStorage.getItem("userInfo"));
      }
      if (sessionStorage.getItem("disbutorInfo")) {
        this.isDistorSelect = true;
      }
      let params = {
        url: window.location.hostname,
      };
      let res = await this.$api.get2(
        this.lee + "/ec/home/v1/getHomeBaseInfo",
        params
      );
      this.copyright = res.data.domain.logoMark;
      this.logoUrl = res.data.domain.logoPic;
    },
    // 切换tab的item
    handleChangeItem(name) {
      this.activeName = name;
    },
    // 切换tab
    changeTabClick() {
      this.tab1 = !this.tab1;
      if (this.tab1) {
        this.activeName = "pwdLogin";
      } else {
        this.activeName = "messageLogin";
      }
    },
    // 登录
    handleLoginClick(obj, flag) {
      // 加密
      const password = this.aesMinEncrypt(
        "ihaierForTodoKey",
        "ihaierForTodo_Iv",
        obj.password
      );

      if (sessionStorage.getItem("fxsId")) {
        //注：如果是店铺的话，type直接设为1，景区的可以是01或者02；01代表散客，02代表分销商
        // this.$set(form, "lgtp", "01");
      }
      if (flag === "01") {
        this.common_login(
          {
            usid: obj.account,
            password: password,
            lgtp: "02",
          },
          flag,
          obj.isSelect
        );
      } else if (flag === "02") {
        this.common_login(
          {
            usid: obj.account,
            password: password,
            lgtp: "01",
          },
          flag,
          obj.isSelect
        );
      } else if (flag === "03") {
        this.message = obj;
        this.is_First_login(obj.account, obj.code);
      }
    },
    // 密码登录或者分销商登录
    async common_login(params, flag, isSelect) {
      try {
        params.url = window.location.hostname;
        let res = await this.$http.post(
          this.baseURL + `/ec/custom/login?url=${window.location.hostname}`,
          params
        );
        if (res.data.code === 200) {
          let custom = res.data.data.custom;
          this.gettoken(custom, params.usid, params.password, flag, isSelect);
          sessionStorage.setItem("distributorType", custom.distributorType);
          sessionStorage.setItem("usid", custom.usid);
          sessionStorage.setItem("corpname", custom.corpname);
        } else {
          this.$req.showMessageModal(this, res, 1);
          this.spinShow = false;
        }
      } catch (err) {
        console.log("login fail:", err);
      }
    },
    // 判断短信验证码登录是不是第一次
    async is_First_login(account, code) {
      try {
        let param = {
          mobile: account,
          lgtp: "01",
          url: window.location.hostname,
        };
        let res = await this.$http.get(
          this.baseURL + "/ec/custom/newCheckMobile",
          { params: param }
        );
        if (res.data.code === 200) {
          if (res.data.data === 0) {
            this.showAlert = true;
          } else {
            this.message_login();
          }
        }
      } catch (err) {}
    },
    // 短信登录
    async message_login() {
      let param = {
        url: window.location.hostname,
        mobile: this.message.account, //用户手机号
        smsCode: this.message.code, //验证码
      };
      this.spinShow = true;
      const loginRes = await this.$http.get(
        this.baseURL + "/ec/custom/customYzmLogin",
        { params: param }
      );
      if (loginRes.data.code === 200) {
        this.spinShow = false;
        const custom = loginRes.data.data;
        this.gettoken(custom, "", "", "03");
      } else {
        this.spinShow = false;
        this.$Modal.warning({
          title: "温馨提示",
          content: loginRes.data.msg,
        });
      }
    },
    //获取token
    gettoken(custom, account, pwd, flag, isSelect = false) {
      const tokenData = {
        username: custom.usid,
        password: custom.password || pwd,
        grant_type: "password",
        scope: "app",
        client_id: "android",
        client_secret: "android",
      };
      sessionStorage.setItem("userName", custom.usid); // 用户名
      sessionStorage.setItem("nickname", custom.note6); // 昵称
      sessionStorage.setItem("lgtp", custom.lgtp); // 用户类别
      sessionStorage.setItem("ustp", custom.ustp); // 分销商等级
      this.$store.commit("setUserName");
      this.$store.commit("setNickname");
      //获取token
      this.$http
        .post(this.baseURL + "/uaa/oauth/token", this.QS.stringify(tokenData))
        .then((res) => {
          if (res.status === 200) {
            sessionStorage.setItem("name", res.data.access_token); // 存储 token
            if (flag === "02") {
              if (isSelect) {
                sessionStorage.setItem(
                  "userInfo",
                  JSON.stringify({ usid: account, pwd })
                ); //记住账号密码
              } else {
                sessionStorage.removeItem("userInfo");
              }
            } else if (flag === "01") {
              if (isSelect) {
                sessionStorage.setItem(
                  "disbutorInfo",
                  JSON.stringify({ usid: account, pwd })
                ); //记住账号密码
              } else {
                sessionStorage.removeItem("disbutorInfo");
              }
            }
            if (
              sessionStorage.getItem("payFlag") &&
              sessionStorage.getItem("payFlag") === "1"
            ) {
              sessionStorage.removeItem("payFlag");
              this.$router.push({
                // name: "firstStepOfTicketPay"
                name: "personalUserHome",
              });
              return;
            }
            if (custom.lgtp === "01") {
              //散客用户
              this.$router.push({
                name: "index_home",
              });
            } else if (custom.lgtp === "02") {
              //分销商用户
              sessionStorage.setItem("route", "distributor-order");
              this.$store.commit("setRoute", "distributor-order");
              this.$router.push({
                name: "purchaseOrder",
              });
            }
          } else {
            this.$req.showMessageModal(
              this,
              "未获取token信息，请刷新后重试",
              2
            );
          }
          this.spinShow = false;
        })
        .catch((err) => {
          this.$req.showMessageModal(this, "账号不存在", 2);
          this.spinShow = false;
        });
    },
    ok() {
      this.message_login();
    },
    // 激活服务条款
    handleServiceRuleClick() {
      this.isModalShow = true;
      this.showAlert = false;
    },
    hideModal() {
      this.isModalShow = false;
    },
    //底部链接跳转
    gotoList(num) {
      this.$store.commit("setLinksName", String(num));
      sessionStorage.setItem("currName", String(num));
      this.$router.push({
        name: "list",
        params: {
          listId: num,
        },
      });
    },
  },
};
</script>
<style lang="less" module>
.container {
  width: 100%;
  min-width: 1200px;
  overflow: hidden;
  .topBox {
    margin: 0 auto;
    width: 1200px;
    .top {
      overflow: hidden;
      width: 100%;
      height: 108px;
      .logo {
        margin-top: 30px;
        margin-left: 0;
        // width: 388px;
        height: 48px;
        // background: url('./imgs/logo_ylt.png') center center no-repeat;
        // background-size: cover;
        cursor: pointer;
      }
    }
  }
  .center {
    height: 600px;
    width: 100%;
    background: url("./imgs/bg.jpg") center center no-repeat;
    background-size: cover;
    .box {
      margin: 0 auto;
      position: relative;
      width: 1200px;
      height: 600px;
      .login {
        position: absolute;
        right: 60px;
        top: 97px;
        width: 380px;
        height: 407px;
        background: #fff;
      }
    }
  }

  .bottom {
    width: 100%;
    height: 212px;
  }
}
</style>

<style lang="less" scoped>
/deep/.ivu-tabs-nav {
  left: 65px;
}
.foot-copyright {
  padding-top: 66px;
  background: transparent;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #999999;
  letter-spacing: 0.5px;
  text-align: center;
  a {
    display: block;
    color: #999999;
  }
}
.linkstring {
  display: inline-block;
  margin-left: 0;
  margin-bottom: 12px;
  -webkit-transform: translate(0);
  -ms-transform: translate(0);
  -moz-transform: translate(0);
  -o-transform: translate(0);
  transform: translate(0);
  li {
    float: left;
    color: #5e5e60;
    padding: 0px 15px;
    line-height: 14px;
    border-right: 1px solid #979797;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0.5px;
    &:last-child {
      border-right: none;
    }
    a {
      color: #5e5e60;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
<style scoped>
.a_tab {
  position: relative;
}
#WX_login {
  position: absolute;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  z-index: 1;
}
#login_container {
  width: 200px;
  height: 200px;
  margin: 5px 50px;
}
.login_item {
  cursor: pointer;
  border-top: 30px solid red;
  border-left: 30px solid red;
  border-bottom: 30px solid #fff;
  border-right: 30px solid #fff;
}

.a_tab >>> .ivu-tabs-bar {
  margin-top: 50px;
  margin-bottom: 0px;
  border-bottom: none;
}
.a_tab >>> .nav-text {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}
/* .a_tab >>> .ivu-tabs-ink-bar {
      left: calc(50% - 90px);
      width: 50px!important;
    } */
.a_tab >>> .ivu-tabs-ink-bar {
  background-color: #4b7ff0;
}
.a_tab >>> .ivu-tabs-nav .ivu-tabs-tab {
  font-size: 17px;
}
.a_tab >>> .ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #4b7ff0;
}
/* .a_tab >>> .ivu-tabs-tab {
      margin-right:0px;
    } */
.a_tab >>> .ivu-tabs-nav .ivu-tabs-tab-active {
  color: #4b7ff0;
}
</style>
